import { Line } from 'vue-chartjs'

export default {
  extends: Line,
  props: {
    dataset: {
      type: Object,
      default: () => ({}),
    },
    options: {
      type: Object,
      default: () => ({}),
    },
  },
  watch: {
    dataset () {
      this.renderChart(this.dataset, this.options)
    },
  },
  mounted () {
    this.renderChart(this.dataset, this.options)
  },
}
